export enum EnumAgreementType {
  /** 用户协议 */
  USER = 'user',
  /** 隐私协议 */
  PROVACY = 'privacy',
  /** 联系我们 */
  Contact = 'contact',
  /** 侵权反馈 */
  Feedback = 'feedback'
}

export enum EnumAboutUsType {
  /** 暄桐教室 */
  Classroom = 'classroom',
  /** 暄桐文房 */
  Wenfang = 'wenfang',
  /** 山林曦照 */
  Art = 'art',
  /** 林曦的小世界 */
  World = 'world'
}
